import { APPLICATIONS } from "@app/shared/constants/applications.constants";
import { ICONS } from "@app/shared/constants/icons.constants";
import { MenuOption } from "@app/shared/models/menu.model";

export const ILH_MENU_OPTIONS = {
  CLIENT_SERVICE_INQUIRY: <MenuOption>{
    id: "ILH0000001",
    componentId: "IlhClientServiceInquiryComponent",
    application: APPLICATIONS.INDIVIDUAL,
    itemDescription: { shortDescription: "MENUS.ILH0000001" },
    icon: ICONS.USER
  },
  NOTE_TYPES: <MenuOption>{
    id: "ILH0000002",
    componentId: "IlhNotesComponent",
    application: APPLICATIONS.INDIVIDUAL,
    itemDescription: { shortDescription: "MENUS.ILH0000002" },
    icon: ICONS.NOTES
  }
};
